import { render } from "./AddReviewModalComponent.vue?vue&type=template&id=34d5d9e9&scoped=true"
import script from "./AddReviewModalComponent.vue?vue&type=script&lang=js"
export * from "./AddReviewModalComponent.vue?vue&type=script&lang=js"

import "./AddReviewModalComponent.vue?vue&type=style&index=0&id=34d5d9e9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d5d9e9"]])

export default __exports__